// extracted by mini-css-extract-plugin
module.exports = {"reportModal":"reportModalBase_reportModal__YQEqc","modalHeader":"reportModalBase_modalHeader__3_dza","modalBody":"reportModalBase_modalBody__2zVaQ"};